// Toast notification utilities

export function showToast(message: string, type: 'success' | 'error' | 'info' = 'info') {
    const container = document.getElementById('toast-container');
    if (!container) return;

    const alertClass = type === 'success' ? 'alert-success' : type === 'error' ? 'alert-error' : 'alert-info';

    const toast = document.createElement('div');
    toast.className = `alert ${alertClass} shadow-lg toast-slide-in`;
    toast.innerHTML = `
        <span>${message}</span>
    `;

    container.appendChild(toast);

    setTimeout(() => {
        toast.remove();
    }, 5000);
}

export function showViewCartPrompt() {
    const container = document.getElementById('toast-container');
    if (!container) return;

    const toast = document.createElement('div');
    toast.className = `alert alert-success shadow-2xl toast-slide-in cursor-pointer hover:scale-105 transition-transform`;
    toast.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <div>
            <div class="font-bold">Item added to cart!</div>
            <div class="text-xs opacity-90">Click here to view your cart</div>
        </div>
    `;

    // Make the toast clickable to open cart drawer
    toast.addEventListener('click', () => {
        const cartDrawer = document.getElementById('cart-drawer') as HTMLInputElement;
        if (cartDrawer) {
            cartDrawer.checked = true;
        }
        toast.remove();
    });

    container.appendChild(toast);

    setTimeout(() => {
        toast.remove();
    }, 5000);
}
